import { memo, ReactNode } from 'react';

type Props = {
    children: ReactNode;
}

export const ModalBody = memo(({ children }: Props) => (
    <div className="vss-modal-body">
        {children}
    </div>
));
